module.exports = __webpack_public_path__ + "static/media/IphoneImage.5d14dc62.png";